import { useState, useRef } from 'react';

const TextToSpeech = ({ content }) => {
  const [ isSpeaking, setIsSpeaking ] = useState(false);
  
  /*const [ isMuted, setIsMuted ] = useState(false);*/
  const utteranceRef = useRef(null);

  const handleStartSpeech = () => {
    if (!isSpeaking) {
      const text = content;
      if (text) {
        utteranceRef.current = new SpeechSynthesisUtterance(text);
        window.speechSynthesis.speak(utteranceRef.current);
        setIsSpeaking(true);
      }
    } else {
      window.speechSynthesis.cancel();
      setIsSpeaking(false);
    }
  };

  /*const handleToggleMute = () => {
    setIsMuted((prevState) => !prevState);
    if (utteranceRef.current) {
      utteranceRef.current.volume = isMuted ? 1 : 0; 
    }
  };

  const handleSpeechEnd = () => {
    setIsSpeaking(false);
    setIsSpeechFinished(true); // Show the "Speak" button after the speech ends
  };*/

  return (
    <div>
      <button className='sound-button' onClick={handleStartSpeech}>{isSpeaking ? <img className='volumeImage' src='../images/sound.gif'/> : <img className='volumeImage' src='../images/volume.png'/>}</button>
      {/* <button onClick={ handleToggleMute }>{isMuted ? 'Unmute' : 'Mute'}</button> */}
    </div>
  );
};

export default TextToSpeech;
